const getFlagrs = async () => {
  const table = localStorage.getItem("env")!;

  const res = await fetch(
    `${process.env.REACT_APP_API_URL}/${table}Flagger/allFlagDetail`,
    {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    }
  );

  if (res.status === 200) {
    return {
      type: "success",
      data: await res.json(),
    };
  } else {
    return {
      type: "error",
      data: "Failed to fetch",
    };
  }
};

export default getFlagrs;
